// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3awr3","productName":"Table_productName__GG_ie"};